<script>
	// NPM Modules
	import config from '@/config.js';
	import debounce from 'lodash/debounce.js';
	// Stores
	import SelectionStore from '@/Stores/Racing/SelectionStore.js';
	// Constants
	import { SelectionStatus } from '@/Constants/Selection.js';
	import { BetType } from '@/Constants/Bet';
	// Components
	import StepInput from '@/Components/StepInput.svelte';

	export let selection;
	export let betType;

	let value = 0;
	let maxRoll = config.RACING_MAX_ROLL;

	$: selectionField =
		betType === BetType.Win ? 'win_price_roll' : betType === BetType.Place ? 'place_price_roll' : null;

	$: selection && selectionField && (value = selection[selectionField] || 0);

	const debounceUpdate = debounce(updatePriceRoll, 500);

	function updatePriceRoll(e) {
		SelectionStore.updatePriceRoll(selection.id, e.detail, betType);
	}
</script>

<StepInput {value} {maxRoll} on:updated={debounceUpdate} enabled={selection.status.id === SelectionStatus.Active} />
